import { Button, Link, Text, TextLevels } from '@bytel/trilogy-react-ts';
import React from 'react';
import { Link as routerLink } from 'react-router-dom';
import './style.css';
import { BtnNavigationProps } from './type';

const ButtonNavigation: React.FC<BtnNavigationProps> = ({ routeRef, titre, dataCy, description }) => {
  return routeRef?.href !== undefined ? (
    <Link to={routeRef?.href} routerLink={routerLink} data-cy={`link-${dataCy}`} removeLinkClass>
      <Button variant="PRIMARY" className="is-fullwidth is-outlined outlinedPrimaryButton" data-cy={`button-${dataCy}`}>
        <Text
          className="is-unselectable"
          level={TextLevels.TWO}
          data-cy={`title-${dataCy}`}
          style={{ textAlign: 'center' }}
        >
          {titre}
        </Text>
        {description && (
          <Text
            className="is-unselectable"
            level={TextLevels.THREE}
            data-cy={`description-${dataCy}`}
            style={{ textAlign: 'center' }}
          >
            {description}
          </Text>
        )}
      </Button>
    </Link>
  ) : null;
};

export default ButtonNavigation;
